import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { i18nTranslate, currencyFormat } from 'src/utils'
import { Icons } from 'src/views/components'
import { getSubscriptionAuthorizedLimit } from 'src/utils/multipleSubscriptionUtils'
import { cartContainer } from 'src/models'
import './styles.scss'

class SubscriptionAmountModal extends React.Component {
  handleClose = () => {
    const { onClose } = this.props
    if (onClose) onClose()
  }

  handleContinue = () => {
    const { onContinue } = this.props
    if (onContinue) onContinue()
  }

  getModalContent = () => {
    const { bagValue = 0, overAllDiscount = 0, shippingCharge = 0 } = this.props

    // Calculate original bag value (before discount)
    const originalBagValue = bagValue + overAllDiscount

    // Get configured authorized limit
    const configuredAuthorizedLimit = getSubscriptionAuthorizedLimit()

    // Get subscription items total from cart
    const subsTotalProperties = cartContainer?.cartResponse?.properties || {}
    const subscriptionItemsTotal = Number(
      subsTotalProperties?.subscriptionItemsTotal ||
        subsTotalProperties?.subsctiptionItemsTotal ||
        0
    )

    // Check cart composition
    const hasCombinedOrder = cartContainer?.hasOneTimeProducts?.() || false
    const hasSubscriptionProduct =
      cartContainer?.hasSubscriptionProduct?.() || false

    // Determine authorization limit
    // For all scenarios: if bagValue >= configuredLimit, use originalBagValue, else use configuredLimit
    const authorizedLimit =
      bagValue >= configuredAuthorizedLimit
        ? originalBagValue
        : configuredAuthorizedLimit

    // Calculate recurring subscription amount (subscription items + shipping)
    const subscriptionRecurringAmount = subscriptionItemsTotal + shippingCharge

    // Format currency using utility function
    const formattedLimit = currencyFormat({
      price: authorizedLimit,
    })
    const formattedBagValue = currencyFormat({
      price: bagValue,
    })
    const formattedSubscriptionTotal = currencyFormat({
      price: subscriptionRecurringAmount,
    })

    // Scenario 1: Approval limit and bag value are same (no discount, simple case)
    if (originalBagValue === bagValue && authorizedLimit === originalBagValue) {
      return i18nTranslate(
        'checkout.recurringSubscriptionLimitOnly',
        `You'll approve a limit of ${formattedLimit} on the next screen for your automatic delivery order.`
      )
    }

    // Scenario 2: Only subscription items
    if (!hasCombinedOrder && hasSubscriptionProduct) {
      return i18nTranslate(
        'checkout.recurringSubscriptionOnly',
        `You'll approve a limit of ${formattedLimit} on the next screen. Today you will be charged ${formattedBagValue} for your first automatic delivery order. Your subsequent monthly recurring charged amount will be ${formattedSubscriptionTotal}.`
      )
    }

    // Scenario 3: Combined order (has one-time and subscription items)
    if (hasCombinedOrder) {
      return i18nTranslate(
        'checkout.recurringSubscriptionCombined',
        `You'll approve a limit of ${formattedLimit} on the next screen. Today you will be charged ${formattedBagValue} for your one-time and first automatic delivery order. Your subsequent monthly recurring charged amount will be ${formattedSubscriptionTotal}.`
      )
    }

    // Default fallback
    return i18nTranslate(
      'checkout.recurringSubscriptionLimitApproval',
      `You'll approve a limit of ${formattedLimit} on the next screen.`
    )
  }

  render() {
    const { show = false } = this.props
    const modalContent = this.getModalContent()

    return (
      <Modal
        className="visible modal-wrapper p-0"
        show={show}
        onHide={this.handleClose}
        centered
        animation={false}>
        <Modal.Header className="border-bottom-0 align-items-center">
          <div className="recurring-modal-header-content">
            <span className="recurring-modal-icon">
              <Icons
                name="product-icon"
                icontype="danger-warning"
                width="24px"
                height="24px"
                color="#ED7219"
              />
            </span>
            <Modal.Title className="title-Recurring-Subscription-Modal mb-0">
              {i18nTranslate(
                'checkout.recurringSubscriptionAmountTitle',
                'Your Recurring Subscription Amount'
              )}
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="recurring-subscription-content">{modalContent}</div>
        </Modal.Body>
        <Modal.Footer className="d-flex flex-column align-items-stretch gap-2 border-top-0">
          <Button
            className="btn btn-primary okay-button mb-2"
            onClick={this.handleContinue}
            data-testid="recurring-amount-continue-btn">
            {i18nTranslate('checkout.okayContinue', 'Okay, continue')}
          </Button>
          <Button
            className="btn btn-outline-primary cancel-button"
            onClick={this.handleClose}
            data-testid="recurring-amount-cancel-btn">
            {i18nTranslate('checkout.cancel', 'Cancel')}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default SubscriptionAmountModal
export { SubscriptionAmountModal }
